import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProcessType } from '../../../Models/configuration-options/process-type';
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'process-type-option',
    templateUrl: './process-type.component.html',
    styleUrls: ['./process-type.component.less'],
    imports: [MatCard, MatCardTitle, MatCardContent, MatRadioGroup, FormsModule, MatRadioButton]
})
export class ProcessTypeConfigOptionComponent implements OnInit {
	@Input() processType: ProcessType;

	@Output() processingTypeChanged = new EventEmitter<ProcessType>();

	ngOnInit(): void {
		if (this.processType === undefined || this.processType === null) {
			this.processType = ProcessType.client;
		}
	}

	processingTypeChange(): void {
		this.processingTypeChanged.emit(this.processType);
	}
}
